import { useCallback, useEffect, useState } from 'react';
import { api } from '../services/api';
import {
  disableSupportPush,
  enableSupportPush,
  getPushSubscriptionState,
  iosAddToHomeHint,
  pushSupported,
  pushUnsupportedHint,
} from '../utils/supportPush';
import { useToast } from './ToastProvider';

const SW_URL = `${import.meta.env.BASE_URL}sw.js`;

export function SupportPushControls({ compact = false }: { compact?: boolean }) {
  const toast = useToast();
  const [state, setState] = useState<'loading' | Awaited<ReturnType<typeof getPushSubscriptionState>>>(
    'loading',
  );
  const [busy, setBusy] = useState(false);
  const hint = iosAddToHomeHint();

  const refresh = useCallback(async () => {
    if (!pushSupported()) {
      setState('unsupported');
      return;
    }
    setState(await getPushSubscriptionState());
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const enable = async () => {
    setBusy(true);
    const res = await enableSupportPush(
      {
        getVapidPublicKey: () => api.getPushVapidKey(),
        subscribePush: (sub) => api.subscribePush(sub),
        unsubscribePush: (endpoint) => api.unsubscribePush(endpoint),
      },
      SW_URL,
    );
    setBusy(false);
    if (res.ok) {
      toast.success('Уведомления включены');
      await refresh();
    } else {
      toast.error(res.message || 'Не удалось включить');
    }
  };

  const disable = async () => {
    setBusy(true);
    await disableSupportPush({
      getVapidPublicKey: () => api.getPushVapidKey(),
      subscribePush: (sub) => api.subscribePush(sub),
      unsubscribePush: (endpoint) => api.unsubscribePush(endpoint),
    });
    setBusy(false);
    toast.info('Уведомления выключены');
    await refresh();
  };

  if (state === 'loading') return null;

  if (state === 'unsupported') {
    return compact ? null : (
      <div className="support-push-controls">
        <p className="muted" style={{ fontSize: '0.85rem', margin: 0 }}>
          {pushUnsupportedHint()}
        </p>
      </div>
    );
  }

  return (
    <div className="support-push-controls">
      {!compact && (
        <p className="muted" style={{ marginTop: 0, fontSize: '0.875rem' }}>
          Уведомления о новых тикетах и сообщениях. На iPhone — только из ярлыка «На экран Домой».
        </p>
      )}
      {hint && (
        <p className="muted" style={{ fontSize: '0.8rem' }}>
          {hint}
        </p>
      )}
      {state === 'subscribed' ? (
        <button type="button" className="btn btn-ghost" disabled={busy} onClick={() => void disable()}>
          Выключить уведомления
        </button>
      ) : state === 'denied' ? (
        <p className="muted" style={{ fontSize: '0.85rem' }}>
          Уведомления заблокированы в настройках браузера.
        </p>
      ) : (
        <button type="button" className="btn btn-primary" disabled={busy} onClick={() => void enable()}>
          Включить уведомления
        </button>
      )}
    </div>
  );
}
